import { type FC, memo } from 'react';

import { Icon } from 'components/icon/Icon';
import { Icons } from 'constants/icons';

import { CONTEXT25_COLORS } from '../constants/context25-campaign';
import * as styles from '../styles';

interface Props {
  onClick: () => void;
}

export const Context25CloseButton: FC<Props> = memo(({ onClick }) => {
  return (
    <button type="button" className={styles.closeStyle} onClick={onClick} aria-label="Close Context 25 campaign banner">
      <Icon name={Icons.Close} width="14px" height="14px" fill={CONTEXT25_COLORS.textAndIcons} />
    </button>
  );
});

Context25CloseButton.displayName = 'Context25CloseButton';
